module.exports = __webpack_public_path__ + "static/media/aib.43ad07c8.svg";